import ERROR_MESSAGES from '../constants/error-messages';

/**
 * Takes an Apollo error string and removes the
 * "GraphQL Error:" prefix.
 *
 * @param {string} error - The error string.
 * @returns {string|any} - The error string without the prefix or the error if not of type string.
 */
export const cleanApolloError = error => {
  if (typeof error === 'string') {
    return error.replace('GraphQL error: ', '');
  }

  return error;
};

/**
 * Determines, extracts, and fetches strings from Apollo errors.
 *
 * @param {string|object} error A string or error object.
 * @param {string} [fallback] A fallback string in case there's nothing else found (optional).
 * @returns {string|any} String if an error string is found or the original error param.
 */
export const getErrorString = (error, fallback) => {
  let message;

  if (error instanceof Error && error.message) {
    message = cleanApolloError(error.message);
  }

  if (typeof error === 'string') {
    message = cleanApolloError(error);
  }

  if (error?.graphQLErrors) {
    const [gqlError] = error.graphQLErrors;

    if (gqlError) {
      message = ERROR_MESSAGES[gqlError.code] || gqlError.message;
    }
  }

  return message || fallback || error;
};

/**
 * Gets a list of all error codes found in a GQL error operation.
 *
 * @param {string|object} error A string or error object.
 * @returns {Array<String>} A list of error codes
 */
export const getGraphQLErrorCodes = error => {
  if (!error?.graphQLErrors) {
    return [];
  }

  return error?.graphQLErrors.map(graphQLError => graphQLError.code);
};
